import React from 'react';
import { ReviewsProps } from 'types/feedback/feedbackTypes';

const GlobalReviews: React.FC<ReviewsProps> = ({ reviews }) => {
  if (!reviews.length) {
    return <div>No reviews available</div>;
  }

  return (
    <div className="reviews-container">
      {reviews.map((review, index) => (
        <div key={index} className="review-card">
          <div className="review-header">
            <span className="reviewer-name">{review.customerName}</span>
          </div>
          <div className="review-rating">            
            <span className="star-review">{review.rating} ★</span>              
            <span className="review-date">{new Date(review.dateCreated).toLocaleDateString()}</span>
          </div>
          <p className="review-comment">{review.comment || "No comment provided"}</p>
        </div>
      ))}
    </div>
  );
};

export default GlobalReviews;
